import { NoDataCard } from "../../../../components/parts";
import { ShaDowBox } from "../../../../components/boxes/ShadowBox";

export const DynamicMicroGrid = () => {
  const title = "Dynamic Micro Grid";

  return (
    <ShaDowBox fullHeight>
      <NoDataCard title={title} type="bubbles" />
    </ShaDowBox>
  );
};
